import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { MonthOptions } from "../config/functions";
import "../styles/EmployeeReportFilter.css";

interface FilterProps {
  filters: {
    year: string;
    month: string;
    employeeId?: string;
  };
  onFilterChange: (field: string, value: string) => void;
  onReset: () => void;
  onFind: () => void;
}

const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 10 }, (_, i) => (currentYear - i).toString());
};

const PayslipFilter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onReset,
  onFind,
}) => {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customYear, setCustomYear] = useState("");
  const [yearOptions, setYearOptions] = useState<string[]>([]);

  useEffect(() => {
    setYearOptions(getYearOptions());

    if (filters.year && !yearOptions.includes(filters.year)) {
      setCustomYear(filters.year);
      setShowCustomInput(true);
    }
  }, [filters.year]);

  const handleDropdownChange = (name: string, value: string) => {
    if (name === "year") {
      if (value === "other") {
        setShowCustomInput(true);
      } else {
        setShowCustomInput(false);
        setCustomYear("");
        onFilterChange(name, value);
      }
    } else {
      onFilterChange(name, value);
    }
  };

  const handleCustomYearChange = (value: string) => {
    setCustomYear(value);
    onFilterChange("year", value);
  };

  const handleFindClick = () => {
    const yearToUse = showCustomInput ? customYear : filters.year;

    if (!yearToUse) {
      toast.warning("Please select or enter a year.");
      return;
    }

    if (showCustomInput && filters.year !== customYear) {
      onFilterChange("year", customYear);
    }

    onFind();
  };

  const handleResetClick = () => {
    setShowCustomInput(false);
    setCustomYear("");
    onReset();
  };

  const monthOptions = MonthOptions().map((opt) => ({
    id: opt.value,
    name: opt.label,
  }));

  return (
    <Form className="task-filter-form">
      <Row className="g-2 align-items-end">
        {/* Year */}
        <Form.Group
          as={Col}
          xs={6}
          sm={4}
          md={3}
          lg={2}
          controlId="year"
          className="task-filter-field"
        >
          <div className="dropdown-label">Year</div>
          {!showCustomInput ? (
            <Form.Select
              value={filters.year && !showCustomInput ? filters.year : ""}
              onChange={(e) => handleDropdownChange("year", e.target.value)}
              className="custom-select"
            >
              <option value="">Select Year</option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
              <option value="other">Other</option>
            </Form.Select>
          ) : (
            <Form.Control
              type="number"
              placeholder="Enter custom year"
              value={customYear}
              onChange={(e) => handleCustomYearChange(e.target.value)}
              min="2000"
              max="2100"
            />
          )}
        </Form.Group>

        {/* Month */}
        <Form.Group
          as={Col}
          xs={6}
          sm={4}
          md={3}
          lg={2}
          controlId="month"
          className="task-filter-field"
        >
          <div className="dropdown-label">Month</div>
          <Form.Select
            value={filters.month}
            onChange={(e) => handleDropdownChange("month", e.target.value)}
            className="custom-select"
          >
            <option value="">All Months</option>
            {monthOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Col xs={12} className="d-flex justify-content-end align-item-center">
          <Button variant="primary" className="mr-2" onClick={handleFindClick}>
            Find
          </Button>
          <Button variant="secondary" onClick={handleResetClick}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PayslipFilter;
